import fetch from '../utils/fetch'


// 黑名单列表
export function getBlacklist (params) {
  return fetch({
    url: '/promotions/lottery/blackList',
    method: 'get',
    params
  })
}
export function addBlacklist (data) {
  return fetch({
    url: '/promotions/lottery/addBlackList',
    method: 'post',
    params:data
  })
}export function removeBlacklist (data) {
  return fetch({
    url: '/promotions/lottery/delBlackList',
    method: 'post',
    params:data
  })
}

// 抽奖活动列表
export function getLuckyDrawRecordList (query) {
  return fetch({
    url: '/promotions/lottery/lotteryList',
    method: 'get',
    params: query
  })
}
// 详情
export function getLotteryDetail (query) {
  return fetch({
    url: '/promotions/lottery/getLottery',
    method: 'get',
    params:query
  })
}
// 添加/编辑抽奖活动，有id就是编辑
export function saveLotterySetting (query) {
  return fetch({
    url: '/promotions/lottery/setLottery',
    method: 'post',
    params: query
  })
}

// 删除抽奖活动
export function delLottery (query) {
  return fetch({
    url: `/promotions/lottery/delLottery`,
    method: 'post',
    params: query
  })
}


// 参与人/中奖名单列表
export function getJoinList (query) {
  return fetch({
    url: `/promotions/lottery/joinList`,
    method: 'get',
    params: query
  })
}

export function getLuckyDrawStatistics (query) {
  return fetch({
    url: `/promotions/lottery/statistic`,
    method: 'post',
    params: query
  })
}


// 兑奖
export function doPrizeExchange (query) {
  return fetch({
    url: `/promotions/lottery/exchange`,
    method: 'post',
    params: query
  })
}